<template>
  <div class="flex w-full flex-col items-center gap-1">
    <template v-for="item in model" :key="item.label">
      <router-link v-if="item.to" v-slot="{ href, navigate, isActive }" :to="item.to" custom>
        <a
          :href="href"
          v-tooltip.right="languageStore.t(item.label)"
          :aria-label="languageStore.t(item.label)"
          :class="[
            'flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-md transition-colors',
            isActive
              ? 'bg-[var(--p-primary-100)] dark:bg-[var(--p-primary-800)]'
              : 'hover:bg-surface-100 dark:hover:bg-surface-800',
          ]"
          @click="navigate"
        >
          <Icons :icon="item.icon" class="shrink-0 font-bold" />
        </a>
      </router-link>

      <NavBarRailGroup v-else-if="hasChildren(item)" :item="item" />
    </template>
  </div>
</template>

<script setup lang="ts">
import Icons from '@/components/subcomponents/Icons.vue'
import { INavBarItem } from '@/models/navbar'
import { useLanguageStore } from '@/stores/LanguageStore'

import NavBarRailGroup from './NavBarRailGroup.vue'

const { model } = defineProps<{ model: INavBarItem[] }>()

const languageStore = useLanguageStore()

const hasChildren = (item: INavBarItem) => Boolean(item.items && item.items.length > 0)
</script>
